import { Colors, Media } from 'enums';
import styled from 'styled-components';

export const NotificationCard = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${Colors.white};
  border-radius: 10px;
  padding: 15px;
  gap: 8px;
  word-break: break-word;

  @media ${Media.notebook} {
    background-color: ${Colors.gray5};
  }
`;

export const NotificationBubble = styled.div`
  position: absolute;
  height: 12px;
  width: 12px;
  border-radius: 99px;
  right: 4px;
  top: -6px;
  border: 2px solid ${Colors.background};
  background-color: ${Colors.yellow1};

  @media ${Media.notebook} {
    height: 18px;
    width: 18px;
    right: 6px;
    top: -9px;
    border: 2px solid ${Colors.white};
  }
`;
